import { unsafeCSS } from 'lit';
import styleText from './app-members-styles.css?inline';

/**
 * Thin barrel over app-members-styles.css.
 *
 * The CSS lives in a real stylesheet so it is visible to the CSS language
 * server, prettier and stylelint; this module only hands it to Lit as a
 * CSSResult. Kept as a module so the exported name is unchanged and no
 * consumer needs editing.
 */
export const styles = unsafeCSS(styleText);
